import * as React from 'react';
import loc from 'owa-localize';
import { closeImmersiveButtonLabel } from './ImmersiveExitButton.locstring.json';
import { ControlIcons } from 'owa-control-icons';
import { IconButton } from '@fluentui/react/lib/Button';
import closeImmersiveReadingPane from 'owa-mail-actions/lib/closeImmersiveReadingPane';
import { getActiveContentTab, TabType } from 'owa-tab-store';

const styles = require('./ImmersiveExitButton.scss');

export interface ImmersiveExitButtonProps {
    iconButtonContainer: string;
    iconButtonStyle?: string;
}

export function ImmersiveExitButton(props: ImmersiveExitButtonProps) {
    const { iconButtonStyle, iconButtonContainer } = props;
    return getActiveContentTab()?.type != TabType.SecondaryReadingPane ? (
        <div className={iconButtonContainer} id="immersiveExitButton">
            <IconButton
                iconProps={{ iconName: ControlIcons.Back, className: styles.exitButtonIcon }}
                title={loc(closeImmersiveButtonLabel)}
                ariaLabel={loc(closeImmersiveButtonLabel)}
                onClick={onCloseButtonClick}
                styles={{ root: styles.exitButton }}
                className={iconButtonStyle}
            />
        </div>
    ) : null;
}

export function onCloseButtonClick(ev: React.MouseEvent<unknown>) {
    closeImmersiveReadingPane('ImmersiveRPCloseButton');
}
